export enum MessageGroup {
  Common = 'common',
  Lobby = 'lobby',
}

export type IncomingMessage = Record<string, unknown>;
